export default function Box({ title, info, body, className1}) {
    return (
        <>
            <div className='box'>
                <div className='box-head'>
                    <p>{title}</p>
                </div>
                {
                    info &&
                    <div className='text-center px-3'>
                        <small className='text-danger'>
                            {info}
                        </small>
                    </div>
                }
                <div className='box-body'>
                    {body}
                </div>
            </div>
        </>
    );
}